module.exports = __webpack_public_path__ + "img/mainhero.777bfcf3.png";